import { useGlobalStore } from '@/stores/globalStore';
import { useInspectionStore } from '@/stores/inspectionStore';
import { useWorkOrderStore } from '@/stores/workOrdersStore';
import { useInspectionBannerStore } from '@/stores/inspectionBannerStore';
import { useInspectionPaginationStore } from '@/stores/inspectionPaginationStore';

export const clearClientStores = () => {
  useGlobalStore.getState().resetStore();
  useInspectionStore.getState().resetStore();
  useWorkOrderStore.getState().resetStore();
  // Shared multi-operator workstation: a dismissed failure warning must not carry
  // over to the next operator.
  useInspectionBannerStore.getState().resetStore();
  // Same reasoning for the inspection-list page size.
  useInspectionPaginationStore.getState().resetStore();

  useGlobalStore.persist.clearStorage();
  useInspectionStore.persist.clearStorage();
  useWorkOrderStore.persist.clearStorage();
  useInspectionBannerStore.persist.clearStorage();
  useInspectionPaginationStore.persist.clearStorage();
};
